import { fg } from '@atlassian/jira-feature-gating';

const isCrossGroupDndEnabledRelayProvider = {
	get(): boolean {
		return fg('jira_issue_navigator_drop_it_like_its_hot_verse_b');
	},
};

export default isCrossGroupDndEnabledRelayProvider;
